export default {
  title: {
    offerLetter: 'My Offer',
    myOffer: 'My Offer'
  },
  label: {
    downloadTip: 'Download the offer letter here',
    idNumberLabel: 'ID Number',
    mobileLabel: 'Mobile',
    signLabel: 'Sign my name',
    rejectCase: 'Decline Reason',
    rejectCaseComment: 'Comments',
    acceptOfferTitle: 'Accept Offer',
    rejectOfferTitle: 'Decline Offer',
    acceptOfferSuccess: 'Offer Accepted!',
    rejectOfferSuccess: 'Offer Declined',
    noOfferData: "You don't have any offers yet",
    signTip: 'Signature'
  },
  btn: {
    rejectOffer: 'Decline',
    clearSign: 'Clear',
    downloadOfferLetter: 'Download',
    viewAllOffer: 'View Offer',
    toOperate: 'To Operate',
    viewDetail: 'View',
    toPersonalHome: 'View Dashboard'
  },
  INVITE_STATUS: {
    INVITED: 'Action Pending',
    ACCEPTED: 'Accepted',
    REJECTED: 'Declined'
  }
}
